import React, { Component } from "react";
import { Chart } from "react-google-charts";
export default class BarGraph extends Component {
  render() {
    const { sensor, kleur, type } = this.props;
    var dateformate = "dd-MM";
    if (type === "maand") {
      dateformate = "MMM-YY";
    }
    if (type === "uur") {
      dateformate = "HH:mm";
    }
    function grdata(sensordata) {
      if (sensordata.data) {
        const columns = [
          { type: "datetime", label: "datum" },
          { type: "number", label: "kWh" },
        ];
        const rows = [];

        sensordata.data.map(function (a, key) {
          if (a.datum && a.value) {
            if (type === "uur" && key > 0) {
              rows.push([new Date(a.datum),  sensordata.data[key-1].value- a.value.toFixed(2)]);
            } else if (type === "dag" || type === "maand") {
              rows.push([new Date(a.datum), a.value.toFixed(2)]);
            }
          } else {
            return;
          }
        });
        return [columns, ...rows];
      }
    }
    return (
      <Chart
        width={"100%"}
        height={"300px"}
        chartType="ComboChart"
        loader={<div>Loading Chart</div>}
        data={sensor ? grdata(sensor) :grdata([])}
        options={{
          hAxis: {
            title: "Datum",
            format: dateformate,
          },
          colors: [kleur],
          vAxis: {
            title: "kWh",
          },
      
          seriesType: "bars",
          series: { 1: { type: "line" } },
        }}
        rootProps={{ "data-testid": "2" }}
      />
    );
  }
}
